import React from "react";
import { CoursTable } from "./scheduler";
import { getColorPair } from "../../helper/randowColor";

const CourseCard = ({ course, onEdit }: { course: CoursTable; onEdit?: () => void }) => {
  const handleDragStart = (e: React.DragEvent, course: CoursTable) => {
    e.dataTransfer.setData("courseId", course.id);
    e.dataTransfer.setData("courseLabel", course.Subject?.label);
    e.dataTransfer.setData(
      "courseSéance_num",
      course.seance_num ? course.seance_num.toString() : "",
    );
    e.dataTransfer.setData("courseClasseId", course.id_classes.join(","));
    e.dataTransfer.setData("courseCourseId", course.id);
  };

  return (
    <div
      draggable={true}
      onDragStart={(e) => handleDragStart(e, course)}
      className="edt-library-course"
      role="button"
      tabIndex={0}
      title="Clic droit pour modifier le cours"
      onContextMenu={(event) => {
        event.preventDefault();
        onEdit?.();
      }}
      onKeyDown={event => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); onEdit?.(); } }}
      style={{ "--course-color": getColorPair(course.TeacherProfil?.id ?? course.id).dark, background: getColorPair(course.TeacherProfil?.id ?? course.id).light } as React.CSSProperties}
    >
      <div className="edt-library-title"><strong>{course.Subject?.label}</strong><i className="ti ti-grip-vertical" aria-hidden="true" /></div>
      <span className="edt-course-teacher">{[course.TeacherProfil?.lastname, course.TeacherProfil?.firstname].filter(Boolean).join(" ") || "Enseignant non renseigné"}</span>
      <span className="edt-library-duration"><i className="ti ti-clock me-1" />{course.seance_num || 0} séance(s)</span>
    </div>
  );
};

export default CourseCard;
